import BulkActionsConfirmActionStepInlineConfirmation from "components/BulkActions/ConfirmActionStep/InlineConfirmation";

import { AiIntegrationsBulkActionsConfirmActionStepProps } from "../types";

type AiIntegrationsBulkActionsConfirmActionStepDefaultProps =
  AiIntegrationsBulkActionsConfirmActionStepProps;

const AiIntegrationsBulkActionsConfirmActionStepDefault = ({
  action,
  bulkActionsVariant,
  onConfirm,
  onCancel,
}: AiIntegrationsBulkActionsConfirmActionStepDefaultProps) => {
  return (
    <BulkActionsConfirmActionStepInlineConfirmation
      variant={bulkActionsVariant}
      actionLabel={action.title.toLowerCase()}
      onConfirm={() =>
        onConfirm(null, {
          view: bulkActionsVariant,
          metadata: {},
        })
      }
      onCancel={onCancel}
    />
  );
};

export default AiIntegrationsBulkActionsConfirmActionStepDefault;
